module.exports = __webpack_public_path__ + "img/task_status_canceled.eb004af2.svg";